export default __webpack_public_path__ + "static/media/archive.30fce2ba.svg";